import React from "react"
import "../Sass/about.css"
import profile from "../img/img3.jpg"

const About = () => {
  const handleClick = (e) => {
    const headerHeight = 40

    const ele = document.querySelector(`#work`)
    const buffer = 45
    const topOfElement =
      window.pageYOffset +
      ele.getBoundingClientRect().top -
      headerHeight -
      buffer
    window.scroll({ top: topOfElement, behavior: "smooth" })
  }

  return (
    <section id="about">
      <div className="container pb-5">
        <div className="row py-5">
          <div className="col-12 pb-md-5">
            <h1 className="sectionname text-center">About Me</h1>
            <hr className="mx-auto" />
          </div>

          <div
            className="col-lg-6 text-center mb-lg-0 mb-5 mt-lg-0 mt-4"
            data-aos="fade-up">
            <img src={profile} alt="profile" className="image-fluid profile" />
          </div>
          <div
            className="col-lg-6 col-md-8 text-justify mt-auto mx-auto"
            data-aos="fade-up">
            <h1 className="text-lg-left text-primary mb-lg-5 mb-4 text-center">
              <span className="about__name__upper text-uppercase">I am</span>
              <br />
              <span className="about__name text-uppercase">Hardik Thakor</span>
            </h1>
            <div className="about__me__text">
              <p>
                Currently I'm Persuing My BTECH(CE) Degree at Charotar
                University Of Science And Technology, Gujarat, India. I Love To
                Code and Devlope Web-Application.I have such a greate experience
                in this field.I have also devlope and deploy many
                web-application.
              </p>
              <div className="text-lg-left text-center text-primary mt-md-4 about__link">
                <button
                  onClick={handleClick}
                  className="btn btn-outline-primary">
                  check what i have done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
